import React from "react";

import { Trans } from "app/utils";

const ThumbnailTitle: React.FC<{}> = () => (
  <div className="Captions-Header__Actions">
    <h2><Trans>Edit Thumbnail</Trans></h2>
  </div>
);

export default ThumbnailTitle;
